import { Box, Button, Center, Text, VStack } from "@chakra-ui/react";
import { useGetTransferHistoryByIdQuery, useUploadProofMutation } from "apis";
import { CloseNewSVG } from "assets";
import { AbstractModal, Uploader } from "components";
import { useState } from "react";
import { useNavigate } from "react-router";
import { uploadFile } from "utils";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  transferId: string;
  hideSkip?: boolean;
}

const UploadProofModal = ({ isOpen, onClose, transferId, hideSkip = false }: Props) => {
  const [file, setFile] = useState<File>();
  const navigate = useNavigate();
  const { refetch } = useGetTransferHistoryByIdQuery(transferId!);

  const [loading, setLoading] = useState(false);
  const [uploadProof, { isLoading }] = useUploadProofMutation();

  const handleProceed = () => {
    navigate(`/transfer-history/${transferId}`, { replace: true });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const upload = await uploadFile(file!, `${transferId}__${Date.now()}`);
      if (!!upload && !!transferId) {
        const proofResponse = await uploadProof({ transferId, uploadUrl: upload.location }).unwrap();

        onClose();

        if (proofResponse) {
          handleProceed();
          refetch();
        }
      }
    } catch (error) {
      setLoading(false);
      console.log(error, "ERROR UPLOAD");
    }
  };
  return (
    <>
      <AbstractModal
        isOpen={isOpen}
        onClose={onClose}
        isCentered={true}
        closeOnOverlayClick={false}
        _content={{
          maxW: { base: "350px", md: "425px" },
          borderRadius: "20px",
          p: { base: "32px 14px", md: "53px 16px" },
          bg: "#fff",
        }}
      >
        <Box
          pos="absolute"
          top={{ base: "3%", md: "3%" }}
          right={{ base: "6%", md: "5%" }}
          onClick={onClose}
          cursor="pointer"
          _hover={{
            zoom: "1.05",
            transition: "all .5s ease-in",
          }}
        >
          <CloseNewSVG />
        </Box>

        <Box>
          <VStack mt="4px !important">
            <Text mb="8px">Upload proof of payment</Text>
            <Uploader label="Upload Payment Receipt" onFiles={(files) => setFile(files[0])} />
          </VStack>
        </Box>

        <Box mt="24px">
          <Button
            w="100%"
            minW={{ base: "auto", md: "380px" }}
            type="button"
            isDisabled={!file || isLoading || loading}
            isLoading={isLoading || loading}
            textTransform="initial"
            fontFamily="var(--bitmama-fonts-heading)"
            _hover={{
              _disabled: {
                opacity: 0.3,
              },
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>

          {!hideSkip && (
            <Center cursor="pointer" mt="16px" onClick={handleProceed} textDecor="underline" fontSize="14px">
              Skip
            </Center>
          )}
        </Box>
      </AbstractModal>
    </>
  );
};

export default UploadProofModal;
